import React from 'react';

import PropTypes from 'prop-types';
import styledC from 'styled-components';

import Button, { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import { useTheme } from '@adsk/alloy-react-styles';

import Footer from './Footer';
import { FooterProps } from '../types';

const FooterItem = styledC.div<{ $minHeight?: string }>`
  display: flex;
  align-items: center;
  ${({ $minHeight }) => ($minHeight ? `min-height: ${$minHeight};` : '')}
`;

const FooterActions = styledC.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`;

const DefaultFooter = ({
  today,
  reset,
  renderFooterActions,
  isTodaySelectable,
}: FooterProps) => {
  const theme = useTheme();
  const footerActionMinHeight = theme.tokens?.component?.datePicker?.footer
    ?.actions?.minHeight as string | undefined;
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <Footer>
      <FooterItem $minHeight={footerActionMinHeight}>
        {renderFooterActions?.({ today, isTodaySelectable })}
      </FooterItem>
      {reset && (
        <FooterItem $minHeight={footerActionMinHeight}>
          <LinkButton onClick={reset} size={Button.SIZES.SMALL}>
            {T.translate('RESET')}
          </LinkButton>
        </FooterItem>
      )}
    </Footer>
  );
};

DefaultFooter.displayName = 'DefaultFooter';

DefaultFooter.propTypes = {
  today: PropTypes.func.isRequired,
  renderFooterActions: PropTypes.func,
  reset: PropTypes.func,
};

export { FooterActions };
export default DefaultFooter;
